import type { Injector } from '@angular/core';

class ContextApplication {
    private static _injector: Injector;

    /**
     * @deprecated Avoid using `Application.injector` to get the dependency.
     * If you are in an injection context, explicitly inject dependencies following https://angular.io/guide/dependency-injection-context.
     * Otherwise, ask for dependencies from the caller.
     */
    public static get injector(): Injector {
        return this._injector;
    }

    public static initialize(value: Injector): void {
        this._injector = value;
    }
}

export { ContextApplication as Application };
